import { Button } from "@porchpass/ui";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  DialogTitle,
} from "@porchpass/ui";
import { UserIcon } from "@porchpass/ui";

// --- Confirm Sales Rep Dialog ---
interface ConfirmSalesRepDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
}

const ConfirmSalesRepDialog: React.FC<ConfirmSalesRepDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
}) => {
  const handleConfirmClick = async () => {
    await onConfirm();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <div className="flex gap-2 items-center">
            <UserIcon size={18} className="text-blue-600" />
            <DialogTitle>Update Sales Rep</DialogTitle>
          </div>
        </DialogHeader>
        <DialogBody>
          <p className="text-base text-[#4a5466]">
            Are you sure you want to update the sales rep for this application?
          </p>
        </DialogBody>
        <DialogFooter>
          <Button
            variant="secondary"
            size="s"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="s"
            onClick={() => void handleConfirmClick()}
          >
            Yes, update sales rep
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmSalesRepDialog;
